(function () {
    document.addEventListener('DOMContentLoaded', () => {
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      let label = document.querySelector('label[for="haptic-switch"]');
      if (!label) {
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.id = 'haptic-switch';
        input.setAttribute('switch', '');
        input.style.display = 'none';
  
        label = document.createElement('label');
        label.setAttribute('for', 'haptic-switch');
        label.style.display = 'none';
  
        document.body.appendChild(input);
        document.body.appendChild(label);
      }
  
      function handleClick(e) {
        const label = document.querySelector('label[for="haptic-switch"]');
        if (isIOS) {
          if (label) {
            label.click();
          }
        } else if (navigator.vibrate) {
          navigator.vibrate(100);
        }
  
        if (e.currentTarget.tagName === 'A') {
          e.preventDefault();
          const href = e.currentTarget.getAttribute('href');
          setTimeout(() => {
            window.location.href = href;
          }, 50);
        } else {
          const link = e.currentTarget.querySelector('a');
          if (link) {
            e.preventDefault();
            setTimeout(() => {
              window.location.href = link.href;
            }, 50);
          }
        }
      }
  
      window.registerHapticClick = function (selector) {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          el.style.cursor = 'pointer';
          el.addEventListener('click', handleClick);
        });
      };
    });
  })();